import React, { Fragment } from "react";

const LastUpdated = ({ user, datetime }) => {

    function formatDate(dateString) {
        try {
            const date = new Date(dateString);
            date.setHours(date.getHours() + 2)
            const options = {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'UTC', 
                hour12: false,
                
            };
            return `${date.toLocaleString('en-ZA', options)}`;
        } catch { return "" }
    }

    return (
        <Fragment>
            <p className="mt-3">Last Updated: {user} <span>({formatDate(datetime)})</span></p>
            
        </Fragment>
    );
};

export default LastUpdated;